'use strict';

var getMaybeFragmentData = require('./getMaybeFragmentData.js');

/**
 * Creates a fragment parser that extracts the fragment data from an array, and passes it to a callback.
 * A single fragment data object can be passed in, or an array of fragment data objects.
 * The resulting function will also accept an already extracted fragment data object
 *
 * @param fragment - The fragment to extract
 * @param callback - The callback to call with the extracted fragment data
 * @returns {function(MaybeFragment<TType>): R}
 */ const createFragmentParser = (fragment, callback)=>(maybeFragmentData)=>{
        const data = getMaybeFragmentData(fragment, Array.isArray(maybeFragmentData) ? maybeFragmentData : [
            maybeFragmentData
        ]);
        return callback(data);
    };

module.exports = createFragmentParser;
